import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

/**
 * Multi-line text field (OG `.v16-textarea`). The vertical-resize sibling of
 * `Input`, sharing its border / focus-ring / dark-fill language.
 */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        'min-h-[76px] w-full resize-y rounded-md border border-card-line bg-input px-4 py-3 text-sm leading-relaxed text-hi outline-none transition-colors',
        'placeholder:text-lo focus:border-accent focus:ring-2 focus:ring-[var(--winr-accent-soft)]',
        className,
      )}
      {...props}
    />
  ),
);
Textarea.displayName = 'Textarea';
